export function getLangTranslate(lang) {
  const langMap = {
    en: () => import(`@shopify/polaris/locales/en.json`),
    "zh-CN": () => import(`@shopify/polaris/locales/zh-CN.json`),
    "zh-TW": () => import(`@shopify/polaris/locales/zh-TW.json`),
    fr: () => import(`@shopify/polaris/locales/fr.json`),
    de: () => import(`@shopify/polaris/locales/de.json`),
    it: () => import(`@shopify/polaris/locales/it.json`),
    es: () => import(`@shopify/polaris/locales/es.json`),
    "pt-PT": () => import(`@shopify/polaris/locales/pt-PT.json`),
    nl: () => import(`@shopify/polaris/locales/nl.json`),
    sv: () => import(`@shopify/polaris/locales/sv.json`),
    da: () => import(`@shopify/polaris/locales/da.json`),
    cs: () => import(`@shopify/polaris/locales/cs.json`),
    nb: () => import(`@shopify/polaris/locales/nb.json`),
    pl: () => import(`@shopify/polaris/locales/pl.json`),
    fi: () => import(`@shopify/polaris/locales/fi.json`),
    tr: () => import(`@shopify/polaris/locales/tr.json`),
    th: () => import(`@shopify/polaris/locales/th.json`),
    ja: () => import(`@shopify/polaris/locales/ja.json`),
    ko: () => import(`@shopify/polaris/locales/ko.json`),
    "pt-BR": () => import(`@shopify/polaris/locales/pt-BR.json`),
  }
  if (langMap[lang]) return langMap[lang]()
  return langMap.en()
}
